import React from 'react'
import './Footer.css';

function Footer() {
  return (
    <div className='site-footer'>
      <footer>
        <p>© 2025 Planeta Solanuhm. All rights reserved.</p>
      </footer>
    </div>
  )
}

export default Footer
